/** The buttons at the bottom of the node inspector. */
import { isOpen } from "../../wm/layout";
import type { JSX } from "solid-js";
import type { Node } from "@protocol/Node";
import { useApp } from "../../app/context";
import { draftFromNode } from "../../shared/drafts";
import { toast } from "../../shared/toast";
import { ArmedButton } from "../../shared/ui";

/** "Save as preset" (opens the presets drawer, or the docked window, with a filled form) and "Delete node". */
export function NodeActions(props: { node: () => Node }): JSX.Element {
  const n = props.node;
  const { actions, view, graph, presets, wm } = useApp();
  /** The whole graph. */
  const g = () => graph.state.graph;
  return (
    <>
      <div class="btnrow">
        <button
          type="button"
          class="btn"
          id="save-as-preset"
          onClick={() => {
            presets.setDraft(draftFromNode(n(), g()));
            // In the docked window when it is in the layout, else in the drawer.
            if (isOpen(wm.layout(), "presets")) wm.open("presets");
            else presets.setDrawer(true);
          }}
        >
          Save as preset
        </button>
        <ArmedButton
          id="delete-node"
          label="Delete node"
          armedLabel={`Click again to delete ${n().name}`}
          onConfirm={() => {
            const name = n().name;
            void actions.removeNode(n().id).then((ok) => ok && (view.selectNode(null), toast(`Deleted ${name}. Press Ctrl+Z to undo.`)));
          }}
        />
      </div>
    </>
  );
}
